import loadable from '@loadable/component'
import { Route } from 'react-router'
import LocaleAwareSwitch from 'components/App/Routes/LocaleAwareSwitch'

import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'

const HeaderMain = loadable(
  () =>
    import(
      '../../client/components/App/Header/HeaderMain/HeaderMain'
    ),
)

function Trip404Page() {
  return (
    <LocaleAwareSwitch>
      <Route exact path="/:regionCode/trip-planner/trip">
        <HttpStatus code={404}>
          <HeaderMain />
          <Error404PageWithOffers />
        </HttpStatus>
      </Route>
      <Route>
        <HttpStatus code={404}>
          <Error404PageWithOffers />
        </HttpStatus>
      </Route>
    </LocaleAwareSwitch>
  )
}

export default Trip404Page
